import { QUERY_KEYS, SERVER_ROUTES } from "@constants/api.routes";
import type { ProfileData } from "../../types";
import { authApi } from "@config/axios/axios.config";
import { useQuery } from "@tanstack/react-query";

export const useProfile = () => {
	return useQuery<ProfileData, Error>({
		queryKey: [QUERY_KEYS.USER.GET_PROFILE],
		queryFn: async (): Promise<ProfileData> => {
			const response = await authApi.get<ProfileData>(SERVER_ROUTES.USER.GET_PROFILE);
			return response?.data;
		},
	});
};
